/*
	Spectral by Pixelarity
	pixelarity.com | hello@pixelarity.com
	License: pixelarity.com/license
*/

declare const breakpoints: any;
declare const browser: any;

var loaded = false;

export const pageReady = (jQuery: any) => {
	if (!loaded) {
		loaded = true;

		let $body = jQuery('body');

		// Play initial animations on page load.
		window.setTimeout(function () {
			$body.removeClass('is-preload');
		}, 100);
	}
};

export const initTheme = (jQuery: any) => {
	var $window = jQuery(window),
		$body = jQuery('body'),
		$banner = jQuery('#banner'),
		$header = jQuery('#header');

	// Breakpoints.
	breakpoints({
		xlarge: ['1281px', '1680px'],
		large: ['981px', '1280px'],
		medium: ['737px', '980px'],
		small: ['481px', '736px'],
		xsmall: [null, '480px']
	});

	// Play initial animations on page load.
	$window.on('load', function () {
		window.setTimeout(function () {
			$body.removeClass('is-preload');
		}, 100);
	});

	// Mobile?
	if (browser.mobile) $body.addClass('is-mobile');
	else {
		breakpoints.on('>medium', function () {
			$body.removeClass('is-mobile');
		});

		breakpoints.on('<=medium', function () {
			$body.addClass('is-mobile');
		});
	}

	// Scrolly.
	jQuery('.scrolly').scrolly({
		speed: 1500,
		offset: $header.outerHeight()
	});

	// Dropdowns.
	jQuery('#nav > ul').dropotron({
		//alignment: 'left',
		hideDelay: 350
	});

	// Menu.
	jQuery('<a href="#navPanel" class="navPanelToggle"><span class="label">Menu</span></a>').appendTo(
		$header
	);

	jQuery(
		'<div id="navPanel">' +
			'<nav>' +
			jQuery('#nav').navList() +
			'</nav>' +
			'<a href="#navPanel" class="close"></a>' +
			'</div>'
	)
		.appendTo($body)
		.panel({
			delay: 500,
			hideOnClick: true,
			hideOnSwipe: true,
			resetScroll: true,
			resetForms: true,
			side: 'right'
		});

	// Header.
	if ($banner.length > 0 && $header.hasClass('alt')) {
		$window.on('resize', function () {
			$window.trigger('scroll');
		});

		$banner.scrollex({
			bottom: $header.outerHeight() + 1,
			terminate: function () {
				$header.removeClass('alt');
			},
			enter: function () {
				$header.addClass('alt');
			},
			leave: function () {
				$header.removeClass('alt');
			}
		});
	}
};
